import SearchInput from 'components/Form/TextField/SearchField.cmp';
import FiltersDropdown from 'components/TaskAdvanceFilters/FiltersDropdown';
import { HeaderCnt } from 'pages/task/TaskListView/TaskListHeader/taskListHeader.style';
import TaskGroupByDropdown from 'pages/task/TaskListView/GroupByDropdown/TaskGroupByDropdown';
import ColumnSelectionDropdown from 'pages/task/TaskListView/ColumnSelectionDropdown/columnSelectionDropdown';
import ExportDropdown from 'pages/task/TaskListView/ExportDropdown';
import CustomButton from 'components/Button/CustomButton';
import AddIcon from '@mui/icons-material/Add';
import { setDialog } from 'store/actions/dialogActions';
import { HasPermission } from 'components/HasPermission';
import { useCustomPermission } from 'utils/CustomHooks/useCustomPermission';
import { useDispatch, useSelector } from 'react-redux';
import selectors from 'store/selectors';
import useTaskFilters from 'utils/CustomHooks/useTaskFilters/useTaskFilters';
import { debounce } from 'lodash';
import { useMemo } from 'react';
import VisibilityToggle from './VisibilityToggle';

interface TaskListHeaderPropTypes {
  disabledAdvanceFilters?: string[];
  forcedAdvanceFilters?: any[];
  isMainView: boolean;
}

function TaskListHeader(props: TaskListHeaderPropTypes) {
  const { disabledAdvanceFilters, forcedAdvanceFilters, isMainView } = props;
  const { PERMISSIONS } = useCustomPermission();
  const filterData: any = useSelector(selectors.getTaskListFilters);
  const { handleSetAdvanceFiltersCommon } = useTaskFilters();
  const dispatch = useDispatch();

  const handleInputChange = debounce(async (e) => {
    const value = e.target.value.trim();
    globalThis.taskListGrid.api.setQuickFilter(value);
  }, 300);

  const hiddenFilters = useMemo(() => {
    let hidden = 'startDate dueDate';
    if (disabledAdvanceFilters) {
      hidden = hidden + ' ' + disabledAdvanceFilters.join(' ');
    }
    return hidden;
  }, [disabledAdvanceFilters]);

  return (
    <HeaderCnt>
      <div className={'lefCnt'}>
        <SearchInput
          fieldProps={{
            onChange: handleInputChange,
          }}
          sx={{ width: 250 }}
        />
        <FiltersDropdown
          selectedFilters={filterData}
          onChange={(filters) =>
            handleSetAdvanceFiltersCommon(filters, forcedAdvanceFilters, {
              skipFilterSave: !isMainView,
            })
          }
          handleClearFilters={() =>
            handleSetAdvanceFiltersCommon(
              null,
              forcedAdvanceFilters ? forcedAdvanceFilters : null,
              { skipFilterSave: !isMainView },
            )
          }
          hideFilters={hiddenFilters}
        />
      </div>
      <div className={'rightCnt'}>
        <TaskGroupByDropdown />
        <ColumnSelectionDropdown />
        <VisibilityToggle
          forcedAdvanceFilters={forcedAdvanceFilters}
          isMainView={isMainView}
        />
        <ExportDropdown />
        {isMainView && (
          <HasPermission permissions={[PERMISSIONS.CAN_MANAGE_TASKS]}>
            <CustomButton
              variant="contained"
              startIcon={<AddIcon style={{ color: 'white', fontSize: 22 }} />}
              style={{ padding: '7px 16px', marginLeft: 12 }}
              onClick={() => {
                dispatch(
                  setDialog({
                    open: true,
                    dialogId: 'createEditTask',
                    // data: {
                    //   ...(isCalendarView() && { returnAllSchedule: true }),
                    // },
                  }),
                );
              }}
            >
              Add
            </CustomButton>
          </HasPermission>
        )}
      </div>
    </HeaderCnt>
  );
}

export default TaskListHeader;
